import { render } from "./SlotBadges.vue?vue&type=template&id=53c1bb32&scoped=true"
import script from "./SlotBadges.vue?vue&type=script&lang=js"
export * from "./SlotBadges.vue?vue&type=script&lang=js"

import "./SlotBadges.vue?vue&type=style&index=0&id=53c1bb32&scoped=true&lang=css"
import "./SlotBadges.vue?vue&type=style&index=1&id=53c1bb32&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c1bb32"]])

export default __exports__